<template lang="pug">
.container
  page-header(
    :disable-back="true"
  )
  .wrapper: .content: div(style="width: 100%")
    .page
      h2 Video Jury „Veranstaltung“
    .center
      svg.play-button(viewBox="0 0 24 24", @click="play", v-if="!played")
        path(fill="#00F3C8", d="M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z")
      video(ref="video" loop)
        source(:src="require(`@/assets/img/video.mp4`)", type="video/mp4")

</template>

<script>
export default {
  props: ['id'],
  data(){
    return {
      played: false
    }
  },
  methods: {
    play(){
      this.played = true
      this.$refs.video.play()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .center{
    text-align: center;
    margin-top: 45px;
  }
  .play-button{
    width: 420px;
    height: 420px;
    position: absolute;
    top: 60%;
    left: 48%;
    transform: translate(-50%, -50%); 
    z-index: 99999;
    margin-top: 50px;
  }
  video{
    width: 70%;
  }
@media (max-width: 1000px) {
  video{
    width: 100%;
  }

  .play-button{
    width: 120px;
    height: 120px;
    top: 63%;
    left: 51%;

  }
}

</style>